export const EUserProfileValues = {
  ENABLED_FEATURES: "EnabledFeatures",
};

export const EEnabledFeatures = {
  PRINT: "print",
  DOWNLOAD_PDF: "downloadPdf",
};

export const CmpType = {
  DIDOMI: "didomi",
  LMO: "lmo",
  SOURCEPOINT: "sourcepoint",
};

export const XitiMode = {
  MINIMAL: "minimal",
  FULL: "full",
};

export const deviceType = {
  PHONE: "smartphone",
  TABLET: "tablet",
  DESKTOP: "desktop",
};



// WEBPACK FOOTER //
// ./src/common/utilities/enums.js